module.exports = __webpack_public_path__ + "media/images/online/online-main-image-pc-fc4294d78a91433704966793e6b9b2a7.png";